import { useState } from "react";
import AdminProfileService from "../services/api";


const useUserProfile = () => {

    const [profileDetails, setProfileDetails] = useState([]);
    const [profileDetailsV2, setProfileDetailsV2] = useState(null);
    const [loading, setLoading] = useState(false)

    const [isLoadingViewUserAccount, setIsLoadingViewUserAccount] = useState(false);
    const [userAccount, setUserAccount] = useState(null);
    const [errorViewUserAccount, setErrorViewUserAccount] = useState(null);
    const [profileTypeList, setProfileTypeList] = useState([]);

    const getProfile = () => {
        setLoading(true)
        AdminProfileService.getProfile().then((res)=>{
            setProfileDetails(res.data.data);
            setProfileTypeList(res.data.data)
            setLoading(false);
            console.log('get profile res aaaaa', res)
        }).catch((err)=>{
            console.log('get profile err', err)
            setLoading(false);
        })
    }

    const viewProfile = () => {
        setLoading(true)
        AdminProfileService.viewProfile().then((res)=>{
            setProfileDetails(res.data.data);
            setProfileDetailsV2(res.data.data)
            setLoading(false);
            console.log('viewProfile res aaaaa', res)
            localStorage.setItem("org_uid", res.data.data.org_uid);
            localStorage.setItem("profile_type", res.data.data.profile_type);
        }).catch((err)=>{
            console.log('viewProfile err', err)
            setLoading(false);
        })
    }

    const viewUserAccount = () => {
        setIsLoadingViewUserAccount(true)
        setUserAccount(null)
        setErrorViewUserAccount(null)
        AdminProfileService.viewUserAccount().then((res)=>{
            setIsLoadingViewUserAccount(false)
            setUserAccount(res.data.data);
            console.log('get profile res aaaaa', res)
        }).catch((err)=>{
            setIsLoadingViewUserAccount(false)
            setErrorViewUserAccount(err)
        })
    }
    

    return{getProfile, profileDetails,profileTypeList, profileDetailsV2, loading, viewProfile, isLoadingViewUserAccount, userAccount, errorViewUserAccount, viewUserAccount}
}

export default useUserProfile